<lib-teleconsultation-maiia [authSrv]="authSrv" [idpCode]="idpCode" [partnerId]="partnerId" ></lib-teleconsultation-maiia>